import React, { useState } from 'react';
import { Crown, Check, X } from 'lucide-react';
import Button from './ui/Button';
import PaymentModal from './PaymentModal';
import AccessModal from './AccessModal';
import { useAuth } from '../contexts/AuthContext';
import { trackInitiateCheckout, trackAddToCart, trackPurchase } from '../utils/metaPixel';

const VIP_PACKAGE = {
  id: 'vip',
  type: 'vip',
  title: 'Upgrade VIP',
  price: 49.9,
  tokens: null,
  product_hash: 'vip_upgrade',
};

const VipModal = ({ isOpen, onClose }) => {
  const { user, isLoggedIn, updateUser, refreshUser } = useAuth();
  const [showPayment, setShowPayment] = useState(false);
  const [showAccess, setShowAccess] = useState(false);

  if (!isOpen && !showPayment) return null;

  const handleStartCheckout = () => {
    if (!isLoggedIn) {
      setShowAccess(true);
      return;
    }

    trackInitiateCheckout(VIP_PACKAGE.price, 'BRL', ['vip_upgrade']);
    trackAddToCart(VIP_PACKAGE.price, 'BRL', 'vip_upgrade');
    setShowPayment(true);
  };

  const handlePaymentSuccess = async () => {
    trackPurchase(VIP_PACKAGE.price, 'BRL', ['vip_upgrade']);
    updateUser({ isVip: true });
    try {
      await refreshUser();
    } catch {
      /* ignore */
    }
    setShowPayment(false);
    onClose();
  };

  const handleClosePayment = () => {
    setShowPayment(false);
  };

  const handleCloseAll = () => {
    setShowPayment(false);
    setShowAccess(false);
    onClose();
  };

  return (
    <>
      {isOpen && !showPayment && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm">
          <div className="relative w-full max-w-md rounded-2xl border border-white/10 bg-zinc-900 p-6 shadow-2xl">
            <button
              onClick={handleCloseAll}
              className="absolute right-4 top-4 text-zinc-500 transition-colors hover:text-zinc-300"
            >
              <X className="h-5 w-5" />
            </button>

            <div className="mb-6 text-center">
              <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-amber-400/15">
                <Crown className="h-6 w-6 text-amber-400" />
              </div>
              <h2 className="text-xl font-semibold text-white">Upgrade para VIP</h2>
              <p className="mt-1.5 text-sm text-zinc-400">
                Desbloqueie todos os recursos premium
              </p>
            </div>

            <ul className="mb-6 space-y-2.5">
              {[
                'Acesso a todos os recursos',
                'Processamento ilimitado',
                'Suporte prioritário',
              ].map((perk) => (
                <li key={perk} className="flex items-center gap-3 text-sm text-zinc-300">
                  <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-emerald-500/15">
                    <Check className="h-3 w-3 text-emerald-400" />
                  </span>
                  {perk}
                </li>
              ))}
            </ul>

            <div className="mb-6 text-center">
              <div className="text-3xl font-bold text-white">R$ 49,90</div>
              <div className="text-sm text-zinc-400">Pagamento único via PIX</div>
            </div>

            <div className="space-y-2.5">
              {user?.isVip ? (
                <Button variant="premium" fullWidth size="lg" disabled>
                  Você já é VIP
                </Button>
              ) : (
                <Button onClick={handleStartCheckout} variant="premium" fullWidth size="lg">
                  Pagar com PIX
                </Button>
              )}
              <Button onClick={handleCloseAll} variant="secondary" fullWidth>
                Cancelar
              </Button>
            </div>
          </div>
        </div>
      )}

      <PaymentModal
        isOpen={showPayment}
        onClose={handleClosePayment}
        packageData={VIP_PACKAGE}
        onSuccess={handlePaymentSuccess}
      />

      <AccessModal
        isOpen={showAccess}
        onClose={() => setShowAccess(false)}
        title="Login necessário"
        message="Faça login para assinar o VIP"
        redirectTo="/?vip=true"
      />
    </>
  );
};

export default VipModal;
